let debugRingsEnabled = false;
// debugRingsEnabled = true;

export const enableDebugRings = (value: boolean) => {
  debugRingsEnabled = value;
};

const debugRingClasses: Record<string, string> = {
  red: 'ring-2 ring-inset ring-debug-red/40',
  green: 'ring-2 ring-inset ring-debug-green/40',
  blue: 'ring-2 ring-inset ring-debug-blue/40',
  orange: 'ring-2 ring-inset ring-debug-orange/40',
  purple: 'ring-2 ring-inset ring-debug-purple/40',
  yellow: 'ring-2 ring-inset ring-debug-orange/40',
};

export const getDebugRing = (color: keyof typeof debugRingClasses) => {
  if (process.env.NODE_ENV !== 'development' || !debugRingsEnabled) {
    return '';
  }
  return debugRingClasses[color];
};
